import { Quote, BadgeCheck } from 'lucide-react';
import { SectionHeading } from '../components/SectionHeading';
import { Reveal } from '../components/Reveal';
import { testimonials } from '../data/content';

export const Testimonials = () => (
  <section data-testid="testimonials-section" className="bg-white">
    <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
      <SectionHeading
        chapter="08"
        eyebrow="Testimonials"
        title="Trusted to Help Brands Move Forward."
        copy="Real projects. Real partnerships. Measurable impact."
      />
      <div className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {testimonials.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.1} className="h-full">
            <figure
              data-testid={`testimonial-card-${i + 1}`}
              className="card-lift flex h-full flex-col rounded-2xl border-2 border-forest bg-forest p-8"
            >
              <Quote size={30} className="mb-5 text-goldlight" strokeWidth={1.4} aria-hidden="true" />
              <blockquote className="flex-1 text-sm leading-relaxed text-white sm:text-[15px]">
                {t.quote}
              </blockquote>
              {t.result && (
                <p
                  data-testid={`testimonial-result-${i + 1}`}
                  className="mt-5 flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.14em] text-goldlight"
                >
                  <BadgeCheck size={14} className="shrink-0" aria-hidden="true" />
                  {t.result}
                </p>
              )}
              <figcaption className="mt-7 flex items-center gap-4 border-t border-white pt-6">
                <span className="flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-full border-2 border-goldlight/60 bg-white p-1.5">
                  <img
                    src={t.logo}
                    alt={`${t.name} logo`}
                    loading="lazy"
                    data-testid={`testimonial-logo-${i + 1}`}
                    className="max-h-9 w-auto max-w-full object-contain"
                  />
                </span>
                <div className="min-w-0">
                  <p className="truncate font-display text-base font-bold text-white">
                    {t.name}
                  </p>
                  {t.fullName && (
                    <p className="truncate text-xs text-white">{t.fullName}</p>
                  )}
                  <p className="mt-0.5 text-xs text-white">{t.location}</p>
                  <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.16em] text-goldlight">
                    {t.service}
                  </p>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
